export const translations = {
  es: {
    // Navigation
    products: 'PRODUCTOS',
    services: 'SERVICIOS',
    support: 'SOPORTE',
    industries: 'INDUSTRIAS',
    learning: 'APRENDIZAJE',
    about: 'NOSOTROS',
    contact: 'CONTACTO',
    buy: 'COMPRAR',
    search: 'BUSCAR',
    search_placeholder: 'Buscar en ECOSOFT...',
    
    // Product Menu
    opus_modules: 'Módulos OPUS',
    budget_module: 'OPUS M1 PRESUPUESTO PROGRAMABLE',
    planning_module: 'OPUS M2 PLANEACIÓN Y CONTROL INTEGRAL',
    purchases_module: 'OPUS M3 ADMINISTRACIÓN DE COMPRAS',
    dependencies_module: 'OPUS M4 DEPENDENCIAS',
    bim_module: 'OPUS M5 CUANTIFICACIÓN BIM',
    erp_module: 'OPUS ERP ENTERPRISE',
    
    // Support Menu
    downloads: 'DESCARGAS',
    support_request: 'CONTACTO',
    faq: 'PREGUNTAS FRECUENTES',
    videos: 'ACADEMIA OPUS (VIDEOS)',
    
    // Industries Menu
    construction: 'CONSTRUCCIÓN',
    infrastructure: 'INFRAESTRUCTURA',
    architecture: 'ARQUITECTURA',
    real_estate: 'INMOBILIARIA',
    
    // Learning Menu
    courses: 'CURSOS',
    certifications: 'CERTIFICACIONES',
    webinars: 'WEBINARS',
    
    // Common
    learn_more: 'Conocer más',
    download: 'Descargar',
    try_free: 'Descargar',
    contact_sales: 'Contactar ventas',
    see_purchase_options: 'Ver opciones de compra'
  }
}; 